import React, { useState, useEffect } from 'react';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import { WrappedInputNumberWithLabel } from '../input';
import LabelWrapper from '../LabelWrapper.component';

export const DimensionsField = ({ dimensions, onChange, onFocus, doValidation = true }) => {
	const dimensionValues = isObject(dimensions) ? dimensions : { length: 0, width: 0, height: 0 };
	const [length, setLength] = useState(dimensionValues.length);
	const [width, setWidth] = useState(dimensionValues.width);
	const [height, setHeight] = useState(dimensionValues.height);
	const [validations, setValidations] = useState({ length: false, width: false, height: false });

	// Flag to block useEffect from running on initial render. No onChange call is needed on load.
	const [firstTimeChange, setFirstTimeChange] = useState(true);

	useEffect(() => {
		if (!firstTimeChange) {
			const changeTimer = setTimeout(() => {
				if (doValidation) {
					setValidations({
						length: length === 0,
						width: width === 0,
						height: height === 0,
					});
				}

				if (isFunction(onChange)) {
					const updatedDimensions = {
						length,
						width,
						height,
					};

					onChange(updatedDimensions);
				}
			}, 500);

			return () => clearTimeout(changeTimer);
		} else {
			setFirstTimeChange(false);
		}
	}, [length, width, height]);

	useEffect(() => {
		const newDimensionValues = isObject(dimensions)
			? dimensions
			: { length: 0, width: 0, height: 0 };
		setLength(newDimensionValues.length);
		setWidth(newDimensionValues.width);
		setHeight(newDimensionValues.height);
	}, [dimensions]);

	const onChangeInput = ({ target: { name, value } }) => {
		if (name === 'length') {
			setLength(value);
		} else if (name === 'width') {
			setWidth(value);
		} else if (name === 'height') {
			setHeight(value);
		}
	};

	const showLabelAfter = true;

	return (
		<div className="common-ui-dimensions-field">
			<WrappedInputNumberWithLabel
				className="dimensions-input"
				errorMessage="Must not be empty"
				isInputInvalid={doValidation ? validations.length : false}
				label='L"'
				showLabelAfter={showLabelAfter}
				uiElementConfig={{
					value: length,
					className: 'dimensions-input',
					inputClassName: doValidation && validations.length ? 'invalid-component' : '',
					showButtons: true,
					min: 0,
					onChange: onChangeInput,
					onFocus,
					name: 'length',
					useGrouping: false,
					dataqa: 'dimensionsfield-length',
					size: length ? length.toString().length * 1.25 : 2,
				}}
			/>
			<WrappedInputNumberWithLabel
				className="dimensions-input"
				errorMessage="Must not be empty"
				isInputInvalid={doValidation ? validations.width : false}
				label='W"'
				showLabelAfter={showLabelAfter}
				uiElementConfig={{
					value: width,
					className: 'dimensions-input',
					inputClassName: doValidation && validations.width ? 'invalid-component' : '',
					showButtons: true,
					min: 0,
					onChange: onChangeInput,
					onFocus,
					name: 'width',
					useGrouping: false,
					dataqa: 'dimensionsfield-width',
					size: width ? width.toString().length * 1.25 : 2,
				}}
			/>
			<WrappedInputNumberWithLabel
				className="dimensions-input"
				errorMessage="Must not be empty"
				isInputInvalid={doValidation ? validations.height : false}
				label='H"'
				showLabelAfter={showLabelAfter}
				uiElementConfig={{
					value: height,
					className: 'dimensions-input',
					inputClassName: doValidation && validations.height ? 'invalid-component' : '',
					showButtons: true,
					min: 0,
					onChange: onChangeInput,
					onFocus,
					name: 'height',
					useGrouping: false,
					dataqa: 'dimensionsfield-height',
					size: height ? height.toString().length * 1.25 : 2,
				}}
			/>
		</div>
	);
};

export const DimensionsFieldWithLabel = LabelWrapper(
	DimensionsField,
	'common-ui-dimensions-field-wrapper'
);
